module.exports = __webpack_public_path__ + "static/spot-light-head-24df04cacc821d3307474d138ad98694.png";